import React from 'react';
import PropTypes from 'prop-types';

import Item from './Item';

export default function Items({ wallet, plan }) {
  return (
    <div className="items">
      <Item
        key="count-sessions"
        title={`${plan.sessions} Annual Session${plan.sessions > 1 ? 's' : ''}`}
        value={`$${plan.plan.base_price}`}
      />
      <Item key="assessments" title="Assessments" value="Free" />
      {wallet.attributes.is_network_discount && (
        <Item
          key="network-discount"
          title="Network Discount"
          value={`-${wallet.attributes.network_discount}%`}
        />
      )}
      {wallet.attributes.is_employer_coverage_discount && (
        <Item
          key="employer-coverage"
          title="Employer Coverage"
          value={`-${wallet.attributes.employer_coverage_discount}%`}
        />
      )}

      <hr />
      <div className="d-flex  justify-content-between">
        <div>Total</div>
        <div className="value">
          $
          {plan.plan.price}
        </div>
      </div>

    </div>
  );
}

Items.propTypes = {
  wallet: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
};
